import { useTranslation } from 'react-i18next'
import Button from '@ui-components/button'
import { v4 as uuidv4 } from 'uuid'
import { useQueryClient } from '@tanstack/react-query'
import * as Sc from './Survey.style'
import SurveyImage from 'assets/img/survey.png'
import { DEVICE_SIZE, TYPE_FEEDBACKS_ACTIONS } from 'utils/constants'
import useMediaQuery from 'hooks/useMediaQuery'
import { USER_KEYS, usePostUserFeedbackPool } from 'hooks/user'
import { STATUS_FLAGS } from 'utils/constants/flags'
import { TYPES_LANGUAGES } from 'utils/constants/languages'

const Survey = () => {
  const { t, i18n } = useTranslation()
  const isTablet = useMediaQuery(`(min-width: ${DEVICE_SIZE.TABLET})`)
  const queryClient = useQueryClient()
  const { mutate: mutateFeedbacksPools } = usePostUserFeedbackPool()
  const { surveyUrl_ca, surveyUrl_es } = window.satisfactionSurvey || {}

  const infoText = [
    t(
      'Ayúdanos a mejorar nuestra plataforma respondiendo a este breve cuestionario'
    ),
    t(
      'Tu contribución es muy importante para nosotros y nos ayudará a seguir mejorando nuestro producto para satisfacer tus necesidades'
    ),
    t('¡Gracias por tu participación!'),
  ]

  const setFeedbacksPools = (feedbackPoolLater = STATUS_FLAGS.FALSE) => {
    queryClient.setQueryData([USER_KEYS.GET_USER], (oldData) => {
      return {
        ...oldData,
        userFlags: {
          ...oldData.userFlags,
          FEEDBACK_POOL: STATUS_FLAGS.FALSE,
          FEEDBACK_POOL_LATER: feedbackPoolLater,
        },
      }
    })
  }

  const handleRedirectToSurveyLink = () => {
    mutateFeedbacksPools(TYPE_FEEDBACKS_ACTIONS.POOL_STARTED)
    setFeedbacksPools()

    const surveyUrl =
      i18n.language === TYPES_LANGUAGES.CA_ES ? surveyUrl_ca : surveyUrl_es
    window.open(surveyUrl, '_blank', 'noreferrer')
  }

  const handleOnClickLaterButton = () => {
    mutateFeedbacksPools(TYPE_FEEDBACKS_ACTIONS.POOL_LATER)
    setFeedbacksPools(STATUS_FLAGS.TRUE)
  }

  return (
    <Sc.CustomModal id='satisfacion-survey-modal'>
      <Sc.Container aria-label='satisfacion-survey-modal'>
        <Sc.CustomText variant={isTablet ? 'title2' : 'title3Mobile'}>
          {t('¡Tu opinión cuenta!')}
        </Sc.CustomText>
        <Sc.InfoContainer>
          {isTablet && (
            <Sc.Image alt='satisfacion-survey-image' src={SurveyImage} />
          )}
          <Sc.Description>
            {!isTablet && (
              <Sc.Image alt='satisfacion-survey-image' src={SurveyImage} />
            )}
            {infoText.map((text) => (
              <Sc.CustomText
                key={uuidv4()}
                variant={isTablet ? 'body' : 'small'}
              >
                {text}
              </Sc.CustomText>
            ))}
          </Sc.Description>
        </Sc.InfoContainer>
        <Sc.Buttons>
          <Button
            dataTestId='button-survey-later'
            onClick={handleOnClickLaterButton}
            small={!isTablet}
            text={t('Más tarde')}
            variant='secondary'
          />
          <Button
            dataTestId='button-survey-submit'
            onClick={handleRedirectToSurveyLink}
            small={!isTablet}
            text={t('Vamos')}
            variant='primary'
          />
        </Sc.Buttons>
      </Sc.Container>
    </Sc.CustomModal>
  )
}

export default Survey
